import React from 'react'

import Navbar from "../components/Navbar"
import Contact from "../components/Contact"
import Footer from '../components/Footer'

const ContactPage = () => {
  return (
    <>
        <Navbar />
        <Contact />
        <Footer/>
    </>
  )
}

export default ContactPage;